import { AllApprovalStatusSubStates, ApprovalStatus } from '../types';
import * as Style from './style.module.scss';

const NOT_FOUND = {
    label: 'Not Found',
    className: ''
};

// HWM-22633: SRS treats "Medical check scheduled" and "Medical check missed"
// as distinct pills with their own labels + colors. Discriminate via the
// approval_sub_status when status === 'MEDICAL_CHECK'.
const MEDICAL_CHECK_SCHEDULED = {
    label: 'Medical check scheduled',
    className: Style.MEDICAL_CHECK_SCHEDULED
};
const MEDICAL_CHECK_MISSED = {
    label: 'Medical check missed',
    className: Style.MEDICAL_CHECK_MISSED
};

// Virtual keys sent from the Status filter dropdown — see backend
// VIRTUAL_STATUS_FILTER_KEYS.
type StatusFilterVirtualKey = 'MEDICAL_CHECK_SCHEDULED' | 'MEDICAL_CHECK_MISSED';

const getApprovalStatus = (
    value?: ApprovalStatus | StatusFilterVirtualKey,
    subStatus?: AllApprovalStatusSubStates | null
) => {
    // Virtual filter keys resolve to the same pills as the (status, sub_status) pairs.
    if (value === 'MEDICAL_CHECK_SCHEDULED') return MEDICAL_CHECK_SCHEDULED;
    if (value === 'MEDICAL_CHECK_MISSED') return MEDICAL_CHECK_MISSED;
    const statuses: Record<ApprovalStatus, { label: string; className: string }> = {
        INITIAL_INTEREST: {
            label: 'Initial interest',
            className: Style.NEW_APPLICATION
        },
        INSURANCE_VALIDATION: {
            // Kept for backwards compat during deploy window — displays as Initial interest
            label: 'Initial interest',
            className: Style.NEW_APPLICATION
        },
        QUALIFIED: {
            label: 'Qualified',
            className: Style.LEAD_QUALIFIED
        },
        MEDICAL_CHECK: MEDICAL_CHECK_SCHEDULED,
        APPROVED: {
            label: 'Enrolled',
            className: Style.APPROVED
        },
        PENDING_ENROLLMENT: {
            label: 'Pending enrollment',
            className: Style.APPROVED
        },
        REJECTED: {
            label: 'Rejected',
            className: Style.REJECTED
        },
        EXPIRED: {
            label: 'Expired',
            className: Style.EXPIRED
        }
    };

    if (value === 'MEDICAL_CHECK') {
        return subStatus === 'MISSED_APPOINTMENT' ? MEDICAL_CHECK_MISSED : MEDICAL_CHECK_SCHEDULED;
    }
    return value && statuses[value] ? statuses[value] : NOT_FOUND;
};

export default getApprovalStatus;
